import { BehaviorSubject } from 'rxjs';

export class calendarDatosCompartidosService {
  private datosSourceListaCalendar = new BehaviorSubject<any>(null);
  datosActualeslistaCalendar = this.datosSourceListaCalendar.asObservable();
  constructor() { }

  actualizarDatos(datos: any) {
    this.datosSourceListaCalendar.next(datos);
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/calendarDatosCompartidosService.ts